<template>
  <div class="nft-filter" @click.stop="openFilter" ref="ntfFilter">
    <img width="16" height="16" src="../assets/filter.svg" alt="filter" />
    <span>{{ current.label }}</span>
    <div :class="{ 'filter-dropdown': true, show: showDropdown }">
      <div
        v-for="(item, index) in filterList"
        :key="index"
        class="dropdown-item"
        @click.stop="changeFilter(item.value)"
        :style="{ color: active_id === item.value ? '#FF6699' : '' }"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "nft-filter",
  data() {
    return {
      showDropdown: false,
      filterListMap: {
        master: [
          {
            value: 0,
            label: "全部",
          },
          {
            value: 1,
            label: "我的收藏",
          },
        ],
        guest: [
          { value: 0, label: "全部" },
          { value: 1, label: "我的收藏" },
          { value: 2, label: "TA的收藏" },
        ],
      },
    };
  },
  props: {
    isMaster: {
      type: Boolean,
      default: false,
    },
    active_id: {
      type: Number,
      default: 0,
    },
    omitAll: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openFilter() {
      this.showDropdown = !this.showDropdown;
    },
    changeFilter(index) {
      this.showDropdown = false;
      this.$emit("changeActive", index);
    },
    handleOutSideClick() {
      this.showDropdown = false;
    },
    handleOutSideScroll() {
      this.showDropdown && (this.showDropdown = false);
    },
  },
  mounted() {
    // 点击关闭
    document.addEventListener("click", this.handleOutSideClick);
    // 滚动关闭
    document.addEventListener("scroll", this.handleOutSideScroll);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutSideClick);
    document.removeEventListener("cliscrollck", this.handleOutSideScroll);
  },
  computed: {
    filterList() {
      const list = this.isMaster
        ? this.filterListMap["master"]
        : this.filterListMap["guest"];
      if (this.omitAll) {
        return list.filter((i) => i.value !== 0);
      }
      return list;
    },
    current() {
      return (
        this.filterList.find((i) => i.value === this.active_id) ||
        this.filterList[0]
      );
    },
  },
};
</script>
<style lang="scss">
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nft-filter {
  position: relative;
  height: 100%;
  line-height: 1;
  @include flex-center;
  font-size: 12px;
  color: #61666d;
  & > span {
    white-space: nowrap;
  }
  .filter-dropdown {
    @include flex-center;
    position: absolute;
    right: -16px;
    top: 40px;
    // visibility: hidden;
    flex-direction: column;
    width: 0px;
    // height: 84px;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(3px);
    border-radius: 8px;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    .dropdown-item {
      @include flex-center;
      width: 100%;
      height: 48px;
    }
    &.show {
      opacity: 1;
      width: 96px;
    }
  }

  img {
    margin-right: 2px;
  }
}
</style>
